import { useTranslation } from 'react-i18next';
import styles from './basicForm.module.scss';
import close from '../../../Assets/images/close.svg';
import ProgressBar from '../../common/ProgressBar/ProgressBar';

function BasicForm({ children, cancel, blue, title, progress, subtitle, step, totalStep }) {
  const { t } = useTranslation();

  return (
    <div className={`${styles.sticky_wrapper}`}>
      <div className={`${styles.form_wrapper} ${blue ? styles.blue : ''}`}>
        <div className={`${styles.form} ${blue ? styles.blue : ''}`}>
          <div role="button" tabIndex={0} onClick={cancel} aria-hidden="true">
            <img alt="close" className={styles.close} src={close} />
          </div>
          {title && <h4 className={styles.header}>{title}</h4>}
          {progress && (
            <ProgressBar
              classes="progressbar"
              progress={progress}
              step={step}
              totalStep={totalStep}
              label={t('jobs.quickapply.progresslabel')}
            />
          )}
          {subtitle && <h6 className={styles.sub_header}>{subtitle}</h6>}
          {children}
        </div>
      </div>
    </div>
  );
}

export default BasicForm;
